import { useAuth } from "@/contexts/auth-context";
import { usePermission, useAnyPermission } from "@/hooks/use-permission";

// Telas da Agenda, na ordem do menu dela (agenda-shell.tsx) — ação da
// categoria "agenda" que libera cada uma pro funcionário (2026-10-09).
export const AGENDA_MENU_ACTIONS = [
  { href: "/agenda", action: "menu_dashboard" },
  { href: "/agenda/agendamentos", action: "menu_agendamentos" },
  { href: "/agenda/chamados", action: "menu_chamados" },
  { href: "/agenda/atendimentos", action: "menu_atendimentos" },
  { href: "/agenda/parametro", action: "menu_parametro" },
  { href: "/agenda/gestao-chips", action: "menu_chips" },
  { href: "/agenda/estoque", action: "menu_estoque" },
  { href: "/agenda/configuracoes", action: "menu_configuracoes" },
  { href: "/agenda/logs", action: "menu_logs" },
] as const;

// Menus que cada conta enxerga:
// - Motorista (pedido 2026-10-08): categoria "menus_app".
// - Funcionário (pedido 2026-10-09): categoria "menus_web" (Início/Mapa/
//   Geocercas/Relatórios/Câmera) + "agenda" (alguma tela da Agenda).
// Cliente/admin continuam vendo os menus como antes (nem têm essas
// categorias na tela de permissões).
export function useAppMenuAccess() {
  const { gpsDriveUser } = useAuth();
  const isMotorista = gpsDriveUser?.accountType === "motorista";
  const isFuncionario = gpsDriveUser?.accountType === "funcionario";
  const mapa = usePermission("menus_app", "mapa");
  const veiculos = usePermission("menus_app", "veiculos");
  const eventos = usePermission("menus_app", "eventos");
  const historico = usePermission("menus_app", "historico");
  const compartilhar = usePermission("menus_app", "compartilhar");
  const webInicio = usePermission("menus_web", "inicio");
  const webMapa = usePermission("menus_web", "mapa");
  const webGeocercas = usePermission("menus_web", "geocercas");
  const webRelatorios = usePermission("menus_web", "relatorios");
  const webCamera = usePermission("menus_web", "camera");
  const anyAgenda = useAnyPermission(
    "agenda",
    AGENDA_MENU_ACTIONS.map((m) => m.action),
  );
  return {
    isMotorista,
    isFuncionario,
    inicio: !isFuncionario || webInicio,
    mapa: isMotorista ? mapa : !isFuncionario || webMapa,
    veiculos: !isMotorista || veiculos,
    eventos: !isMotorista || eventos,
    historico: !isMotorista || historico,
    compartilhar: !isMotorista || compartilhar,
    geocercas: !isFuncionario || webGeocercas,
    relatorios: !isFuncionario || webRelatorios,
    camera: !isFuncionario || webCamera,
    agenda: !isFuncionario || anyAgenda,
  };
}
